/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionOnboarding } from './CompetitionOnboarding';
import {
    CompetitionOnboardingFromJSON,
    CompetitionOnboardingFromJSONTyped,
    CompetitionOnboardingToJSON,
    CompetitionOnboardingToJSONTyped,
} from './CompetitionOnboarding';
import type { RecurrenceConfig } from './RecurrenceConfig';
import {
    RecurrenceConfigFromJSON,
    RecurrenceConfigFromJSONTyped,
    RecurrenceConfigToJSON,
    RecurrenceConfigToJSONTyped,
} from './RecurrenceConfig';
import type { CompetitionStatus } from './CompetitionStatus';
import {
    CompetitionStatusFromJSON,
    CompetitionStatusFromJSONTyped,
    CompetitionStatusToJSON,
    CompetitionStatusToJSONTyped,
} from './CompetitionStatus';
import type { CompetitionFaq } from './CompetitionFaq';
import {
    CompetitionFaqFromJSON,
    CompetitionFaqFromJSONTyped,
    CompetitionFaqToJSON,
    CompetitionFaqToJSONTyped,
} from './CompetitionFaq';
import type { CompetitionItem } from './CompetitionItem';
import {
    CompetitionItemFromJSON,
    CompetitionItemFromJSONTyped,
    CompetitionItemToJSON,
    CompetitionItemToJSONTyped,
} from './CompetitionItem';
import type { PrerequisiteResponse } from './PrerequisiteResponse';
import {
    PrerequisiteResponseFromJSON,
    PrerequisiteResponseFromJSONTyped,
    PrerequisiteResponseToJSON,
    PrerequisiteResponseToJSONTyped,
} from './PrerequisiteResponse';
import type { StreamingSettings } from './StreamingSettings';
import {
    StreamingSettingsFromJSON,
    StreamingSettingsFromJSONTyped,
    StreamingSettingsToJSON,
    StreamingSettingsToJSONTyped,
} from './StreamingSettings';

/**
 * 
 * @export
 * @interface CompetitionResponse
 */
export interface CompetitionResponse {
    /**
     * 
     * @type {string}
     * @memberof CompetitionResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CompetitionResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CompetitionResponse
     */
    description?: string;
    /**
     * 
     * @type {Array<CompetitionItem>}
     * @memberof CompetitionResponse
     */
    items: Array<CompetitionItem>;
    /**
     * 
     * @type {boolean}
     * @memberof CompetitionResponse
     */
    isRecurring: boolean;
    /**
     * 
     * @type {RecurrenceConfig}
     * @memberof CompetitionResponse
     */
    recurrence?: RecurrenceConfig;
    /**
     * 
     * @type {string}
     * @memberof CompetitionResponse
     */
    templateId?: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionResponse
     */
    instanceNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof CompetitionResponse
     */
    instanceDate?: number;
    /**
     * 
     * @type {string}
     * @memberof CompetitionResponse
     */
    eventName?: string;
    /**
     * 
     * @type {string}
     * @memberof CompetitionResponse
     */
    sponsorId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompetitionResponse
     */
    ruleSetId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompetitionResponse
     */
    hero?: string;
    /**
     * 
     * @type {string}
     * @memberof CompetitionResponse
     */
    banner?: string;
    /**
     * 
     * @type {CompetitionOnboarding}
     * @memberof CompetitionResponse
     */
    onboardingSection?: CompetitionOnboarding;
    /**
     * 
     * @type {Array<CompetitionFaq>}
     * @memberof CompetitionResponse
     */
    faqs?: Array<CompetitionFaq>;
    /**
     * 
     * @type {CompetitionStatus}
     * @memberof CompetitionResponse
     */
    status: CompetitionStatus;
    /**
     * 
     * @type {string}
     * @memberof CompetitionResponse
     */
    createdBy?: string;
    /**
     * 
     * @type {StreamingSettings}
     * @memberof CompetitionResponse
     */
    streamingSettings?: StreamingSettings;
    /**
     * 
     * @type {string}
     * @memberof CompetitionResponse
     */
    displayMode?: string;
    /**
     * 
     * @type {string}
     * @memberof CompetitionResponse
     */
    micrositeSlug?: string;
    /**
     * 
     * @type {Array<PrerequisiteResponse>}
     * @memberof CompetitionResponse
     */
    prerequisites: Array<PrerequisiteResponse>;
    /**
     * 
     * @type {number}
     * @memberof CompetitionResponse
     */
    atRiskPausedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof CompetitionResponse
     */
    atRiskReason?: string;
    /**
     * 
     * @type {string}
     * @memberof CompetitionResponse
     */
    atRiskScoringTemplateId?: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionResponse
     */
    atRiskCancelledForRefundAt?: number;
    /**
     * 
     * @type {string}
     * @memberof CompetitionResponse
     */
    scoringGameId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompetitionResponse
     */
    requiredEventTypeIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CompetitionResponse
     */
    ratingFloor?: number;
    /**
     * 
     * @type {number}
     * @memberof CompetitionResponse
     */
    ratingBandMin?: number;
    /**
     * 
     * @type {number}
     * @memberof CompetitionResponse
     */
    ratingBandMax?: number;
    /**
     * 
     * @type {string}
     * @memberof CompetitionResponse
     */
    poolIsolation?: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionResponse
     */
    trustScoreFloor?: number;
    /**
     * 
     * @type {number}
     * @memberof CompetitionResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof CompetitionResponse
     */
    updatedAt: number;
}



/**
 * Check if a given object implements the CompetitionResponse interface.
 */
export function instanceOfCompetitionResponse(value: object): value is CompetitionResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('isRecurring' in value) || value['isRecurring'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('prerequisites' in value) || value['prerequisites'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function CompetitionResponseFromJSON(json: any): CompetitionResponse {
    return CompetitionResponseFromJSONTyped(json, false);
}

export function CompetitionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'items': ((json['items'] as Array<any>).map(CompetitionItemFromJSON)),
        'isRecurring': json['isRecurring'],
        'recurrence': json['recurrence'] == null ? undefined : RecurrenceConfigFromJSON(json['recurrence']),
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'instanceNumber': json['instanceNumber'] == null ? undefined : json['instanceNumber'],
        'instanceDate': json['instanceDate'] == null ? undefined : json['instanceDate'],
        'eventName': json['eventName'] == null ? undefined : json['eventName'],
        'sponsorId': json['sponsorId'] == null ? undefined : json['sponsorId'],
        'ruleSetId': json['ruleSetId'] == null ? undefined : json['ruleSetId'],
        'hero': json['hero'] == null ? undefined : json['hero'],
        'banner': json['banner'] == null ? undefined : json['banner'],
        'onboardingSection': json['onboardingSection'] == null ? undefined : CompetitionOnboardingFromJSON(json['onboardingSection']),
        'faqs': json['faqs'] == null ? undefined : ((json['faqs'] as Array<any>).map(CompetitionFaqFromJSON)),
        'status': CompetitionStatusFromJSON(json['status']),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'streamingSettings': json['streamingSettings'] == null ? undefined : StreamingSettingsFromJSON(json['streamingSettings']),
        'displayMode': json['displayMode'] == null ? undefined : json['displayMode'],
        'micrositeSlug': json['micrositeSlug'] == null ? undefined : json['micrositeSlug'],
        'prerequisites': ((json['prerequisites'] as Array<any>).map(PrerequisiteResponseFromJSON)),
        'atRiskPausedAt': json['atRiskPausedAt'] == null ? undefined : json['atRiskPausedAt'],
        'atRiskReason': json['atRiskReason'] == null ? undefined : json['atRiskReason'],
        'atRiskScoringTemplateId': json['atRiskScoringTemplateId'] == null ? undefined : json['atRiskScoringTemplateId'],
        'atRiskCancelledForRefundAt': json['atRiskCancelledForRefundAt'] == null ? undefined : json['atRiskCancelledForRefundAt'],
        'scoringGameId': json['scoringGameId'] == null ? undefined : json['scoringGameId'],
        'requiredEventTypeIds': json['requiredEventTypeIds'] == null ? undefined : json['requiredEventTypeIds'],
        'ratingFloor': json['ratingFloor'] == null ? undefined : json['ratingFloor'],
        'ratingBandMin': json['ratingBandMin'] == null ? undefined : json['ratingBandMin'],
        'ratingBandMax': json['ratingBandMax'] == null ? undefined : json['ratingBandMax'],
        'poolIsolation': json['poolIsolation'] == null ? undefined : json['poolIsolation'],
        'trustScoreFloor': json['trustScoreFloor'] == null ? undefined : json['trustScoreFloor'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function CompetitionResponseToJSON(json: any): CompetitionResponse {
    return CompetitionResponseToJSONTyped(json, false);
}

export function CompetitionResponseToJSONTyped(value?: CompetitionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'items': ((value['items'] as Array<any>).map(CompetitionItemToJSON)),
        'isRecurring': value['isRecurring'],
        'recurrence': RecurrenceConfigToJSON(value['recurrence']),
        'templateId': value['templateId'],
        'instanceNumber': value['instanceNumber'],
        'instanceDate': value['instanceDate'],
        'eventName': value['eventName'],
        'sponsorId': value['sponsorId'],
        'ruleSetId': value['ruleSetId'],
        'hero': value['hero'],
        'banner': value['banner'],
        'onboardingSection': CompetitionOnboardingToJSON(value['onboardingSection']),
        'faqs': value['faqs'] == null ? undefined : ((value['faqs'] as Array<any>).map(CompetitionFaqToJSON)),
        'status': CompetitionStatusToJSON(value['status']),
        'createdBy': value['createdBy'],
        'streamingSettings': StreamingSettingsToJSON(value['streamingSettings']),
        'displayMode': value['displayMode'],
        'micrositeSlug': value['micrositeSlug'],
        'prerequisites': ((value['prerequisites'] as Array<any>).map(PrerequisiteResponseToJSON)),
        'atRiskPausedAt': value['atRiskPausedAt'],
        'atRiskReason': value['atRiskReason'],
        'atRiskScoringTemplateId': value['atRiskScoringTemplateId'],
        'atRiskCancelledForRefundAt': value['atRiskCancelledForRefundAt'],
        'scoringGameId': value['scoringGameId'],
        'requiredEventTypeIds': value['requiredEventTypeIds'],
        'ratingFloor': value['ratingFloor'],
        'ratingBandMin': value['ratingBandMin'],
        'ratingBandMax': value['ratingBandMax'],
        'poolIsolation': value['poolIsolation'],
        'trustScoreFloor': value['trustScoreFloor'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

